import * as React from 'react'
import styled from 'styled-components'

import { t } from '@owl-nest/localize'
import * as plume from '@ulule/owl-kit-components/next'
import * as services from '@owl-nest/services'

import { CommentForm } from './CommentBox/CommentForm'
import { CommentList } from './CommentBox/CommentList'

type CommentBox = {
  objectId: number | string
  isCommentingAllowed?: boolean
}

const Connect = React.lazy(async () => ({ default: (await import('@owl-nest/connect')).Connect }))

const PAGINATION_LIMIT = 10

export function CommentBox({ objectId, isCommentingAllowed = false }: CommentBox): React.ReactElement<any> {
  const auth = services.user.useAuth()
  const { createComment, response, queryNext, queryReplies, replyToComment, deleteComment } =
    services.comment.useNewsComments(objectId, {
      fetchOnMount: true,
      params: {
        limit: PAGINATION_LIMIT,
        since: Date.now(),
      },
    })

  const comments = response.data?.comments
  const meta = response.data?.meta

  if (!comments || !meta) {
    return <plume.Spinner />
  }

  return (
    <>
      {auth.type === 'loggedin' ? (
        <>
          {isCommentingAllowed && (
            <CommentForm
              currentUser={auth.user}
              onSubmit={async (values) => {
                await createComment({
                  comment: values.comment,
                })
              }}
              submitLabel={t('Send')}
            />
          )}
        </>
      ) : (
        <React.Suspense fallback={<plume.Spinner />}>
          <ConnectWrapper>
            <plume.styles.heading.M>{t('Login to leave a comment')}</plume.styles.heading.M>
            <Connect extraFields={[]} />
          </ConnectWrapper>
        </React.Suspense>
      )}
      {comments && (
        <CommentList
          comments={comments}
          meta={meta}
          objectId={objectId}
          queryNext={queryNext}
          queryReplies={queryReplies}
          replyToComment={replyToComment}
          deleteComment={deleteComment}
        />
      )}
    </>
  )
}

const ConnectWrapper = styled.div`
  max-width: 430px;
  margin: 0 auto 30px;

  ${plume.styles.heading.M} {
    text-align: center;
    margin-bottom: 30px;
  }
`
